import { createFileRoute } from '@tanstack/react-router'
import { VisibilityDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import { ProfileVisibilityDialog } from '@/routes/_app/-components/user-menu-components/profile-visibility-dialog'

export const Route = createFileRoute('/@modal/settings/visibility')({
  staticData: { slotScope: '/_app', slotOutlet: 'userMenu' },
  pendingComponent: VisibilityDialogPending,
  component: ProfileVisibilitySlot,
})

function ProfileVisibilitySlot() {
  const slot = useModalSlot(Route)
  return <ProfileVisibilityDialog {...slot} />
}
